module.exports = __webpack_public_path__ + "img/Support-skill-212.ec4ceddf.png";